import { render, staticRenderFns } from "./bindBank.vue?vue&type=template&id=7bf753c0&"
import script from "./bindBank.vue?vue&type=script&lang=js&"
export * from "./bindBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports